// extracted by mini-css-extract-plugin
export default {"imageWrapper":"XL-z","twoColumnImage":"YL-z"};